/* ScatterPlot-with-trendline.jsx
Requires: react and d3 (ie  `npm install -S react d3`)
See the LinearGraph for an example of calling ScatterPlot
*/
import React from "react"
import { scaleLinear, max, axisLeft, axisBottom, select, zoom } from "d3";
import * as d3 from "d3";

const data = [[0, 3],[5, 13],[10, 22]];

export default class Otherside extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // let zoom = d3.behavior.zoom()
    // .on('zoom', handleZoom);
    
    // select('svg')
    // .call(zoom);
  }

  handleZoom(e) {
    select('svg g')
      .attr('transform', e.transform);
  }

  render() {
    const margin = { top: 20, right: 15, bottom: 60, left: 60 }
    const width = 800 - margin.left - margin.right
    const height = 600 - margin.top - margin.bottom
    const data = [[0, 3],[5, 13],[10, 22]]

    const x = scaleLinear()
      .domain([
        0,
        max(data, function(d) {
          return d[0]
        })
      ])
      .range([0, width])

    const y = scaleLinear()
      .domain([
        0,
        max(data, function(d) {
          return d[1]
        })
      ])
      .range([height, 0])

    return (
      <div>
        <h3> Otherside </h3>
        <svg
            
          width={width + margin.right + margin.left}
          height={height + margin.top + margin.bottom}
          className="chart"
        >
          <g
            transform={"translate(" + margin.left + "," + margin.top + ")"}
            width={width}
            height={height}
            className="main"
          >
            <RenderCircles data={data} scale={{ x, y }} />            
          </g>
        </svg>
      </div>
    )
  }
}

class RenderCircles extends React.Component {
  render() {
    let renderCircles = this.props.data.map((coords, i) => (
      <circle
        cx={this.props.scale.x(coords[0])}
        cy={this.props.scale.y(coords[1])}
        r="2"
        style={{ fill: "rgba(25, 158, 199, .9)" }}
        key={i}
      />
    ))
    return <g>{renderCircles}</g>
  }
}
